import React, { useEffect, useState } from "react";
import ModalVideo from "react-modal-video";
import { getCMSAssets, getCMSGeneral } from "../../utils/cms.utils";

/* ===== YOUTUBE ID PARSER ===== */
const getYoutubeVideoId = (url = "") => {
    if (!url) return null;

    const match = url.match(
        /(?:youtube\.com\/.*v=|youtu\.be\/)([^&?/]+)/i
    );

    return match ? match[1] : null;
};

const Video = () => {
    const title = "Get In Touch RAR in One Minute";
    const subtitle = "PT. Raja Alam Raya — General Constructor Since 2016";

    const [openVideo, setOpenVideo] = useState(false);
    const [general, setGeneral] = useState(null);
    const [assets, setAssets] = useState(null);

    useEffect(() => {
        setGeneral(getCMSGeneral());
        setAssets(getCMSAssets());
    }, []);

    const videoId = getYoutubeVideoId(general?.youtubeUrl);

    return (
        <>
            <section
                className="video__two"
                style={{
                    backgroundImage: assets?.video_banner
                        ? `url(${assets.video_banner})`
                        : undefined,
                }}
            >
                <div className="video__overlay" />

                <div className="container video__content">
                    <div className="row">
                        <div className="col-xl-12 text-center">

                            {/* PLAY BUTTON */}
                            {videoId && (
                                <div className="video__two-icon item_bounce">
                                    <div
                                        className="video__play video-pulse"
                                        onClick={() => setOpenVideo(true)}
                                        role="button"
                                        aria-label="Play video"
                                    >
                                        <i className="fas fa-play" />
                                    </div>
                                </div>
                            )}

                            {/* TITLE */}
                            <h2 className="video__title">{title}</h2>

                            {/* SUBTITLE */}
                            <p className="video__subtitle">{subtitle}</p>

                            {/* CTA */}
                            {general?.youtubeUrl && (
                                <a
                                    href={general.youtubeUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="video__watch"
                                >
                                    Watch on YouTube
                                </a>
                            )}

                        </div>
                    </div>
                </div>
            </section>

            {/* MODAL VIDEO */}
            {videoId && (
                <ModalVideo
                    className="video-modal"
                    channel="youtube"
                    autoplay
                    isOpen={openVideo}
                    videoId={videoId}
                    onClose={() => setOpenVideo(false)}
                />
            )}
        </>
    );
};

export default Video;
